import { type ApplicationSteps, type PartialRecord } from 'share/types'
import { pathnames } from 'utils/constants'

export const getDev1FlowPaths = (key: ApplicationSteps): string | undefined => {
  const paths: PartialRecord<ApplicationSteps, string> = {
    // Prescoring steps
    FETCH_PERSONAL_INFO: pathnames['internal-step-loader'],
    Q19_CALL: pathnames['q19-call']
  }
  return paths[key]
}
